import { render, staticRenderFns } from "./FluxoAlternativo.vue?vue&type=template&id=d72bc42e&scoped=true&"
import script from "./FluxoAlternativo.vue?vue&type=script&lang=js&"
export * from "./FluxoAlternativo.vue?vue&type=script&lang=js&"
import style0 from "./FluxoAlternativo.vue?vue&type=style&index=0&id=d72bc42e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72bc42e",
  null
  
)

export default component.exports